import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Localization, PersistenceObjectType, PersistenceScope, SessionContext, SettingsManager, ViamapPersistenceLayer } from "@viamap/viamap2-common";
import { FileImportContext } from "./FileImporter";
import { FileImportType } from "./FileImportHooks";
import { MIBIcon } from "src/componentsUtils/MIBIcon";


type fileAction = "Open" | "Override" | "Delete"


/// Used for support for old React Coponents
export const CloudLayerList = (prop: { show: boolean, close: () => void, prefix?: string }) => {
  const { state: sessionState } = useContext(SessionContext);
  const { importCallBack } = useContext(FileImportContext)
  const [fileList, setFileList] = useState<any[]>([])

  function onClickClose() {
    prop.close();
  }



  const closeButton = (
    <MIBIcon
      icon="dismiss"
      onClick={() => onClickClose()}
    />
  );

  function fileAction(action: fileAction, key) {
    let persit = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"))
    switch (action) {
      case "Open":
        importCallBack({
          fileImportType: FileImportType.FileFetch,
          url: sessionState.userRef + "/" + key,
        })
        return
      case "Override": {
        return
      }
      case "Delete": {
        persit.deleteObject(PersistenceScope.User, PersistenceObjectType.MapitMaps, sessionState.customerRef, sessionState.userRef, key)
        setFileList((a) => {
          return a.filter((b) => b.key !== key)
        })
        return
      }
    }
  }

  async function getFileList(setList: (a: any[]) => void) {
    let domainName = sessionState.customerRef;
    let userId = sessionState.userRef;
    let persit = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"))
    let prefixPath = persit.createPrefix(PersistenceScope.User, PersistenceObjectType.MapitMaps, domainName, userId)
    let prefix = prop.prefix ? prop.prefix : prefixPath
    let listing = (await persit.getListingS3(prefix) as any[]).map((a) => a.Key).filter((e) => e !== prefix).map((a) => a.split("/").at(-1))

    let heads: any[] = []
    for (let i of listing) {
      let k = await persit.headObjectS3(prefix + "/" + i);
      heads.push({ value: k, ref: i });
    }
    setList(heads)
  }

  useEffect(() => {
    getFileList(setFileList)
  }, [sessionState.userRef])

  if (!prop.show) {
    return (null);
  }

  return (
    <Modal.Dialog className="mit-report-dialog" >
      <Modal.Header>
        <Modal.Title>
          {closeButton}
          Fil oversigt
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fileList.map((a) => {
          return (
            <div key={a.ref}>
              {a.value.Metadata.maptitle}
              <button onClick={() => fileAction("Open", a.ref)} >Open</button>
              <button onClick={() => fileAction("Override", a.ref)} >Override (TODO)</button>
              <button onClick={() => fileAction("Delete", a.ref)} >Delete</button>
            </div>
          )
        })
        }
      </Modal.Body>
    </Modal.Dialog>
  );
};